
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-intelligence/talent-ai",
      function () {
        return require("private-next-pages/talent-intelligence/talent-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-intelligence/talent-ai"])
      });
    }
  